import { Box } from '@locus-taxy/encore-mui';
import TeamSelect from '../TeamSelect';
import { useEntityMetadata } from '../../api/endpoints/useEntityMetadata';
import { useClientId } from '../../hooks/useClientId';
import { useCurrentEntityName } from '../../hooks/useCurrentEntityName';

export default function DashboardToolbarActions() {
  const clientId = useClientId();
  const entityName = useCurrentEntityName();

  // Fetch metadata only when on an entity route
  const { data: metadataResponse } = useEntityMetadata(clientId, entityName);

  // Show team filter by default, hide only if applyTeamFilter is explicitly false
  const applyTeamFilter =
    metadataResponse?.data?.frontend?.gridView?.applyTeamFilter;
  const showTeamFilter = applyTeamFilter !== false;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {showTeamFilter && <TeamSelect />}
    </Box>
  );
}
